module.exports = require('../_components/@alicd/next-cascader-select/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/cascader-select/index.js
// module id = 593
// module chunks = 0